import { AuthenticationMethod } from './types'

interface AuthenticationConfig {
  color: string
  backgroundColor: string
  icon: string
}

export const AUTHENTICATION_METHODS: AuthenticationMethod[] = ['open', 'psk', '802.1x']

export const AUTHENTICATION_CONFIG: Record<AuthenticationMethod, AuthenticationConfig> = {
  open: {
    color: '#587F31',
    backgroundColor: '#E6F0D7',
    icon: 'lock-open'
  },
  psk: {
    color: '#2570EB',
    backgroundColor: '#DBE8FE',
    icon: 'key'
  },
  '802.1x': {
    color: '#8B5CF6',
    backgroundColor: '#EDE9FE',
    icon: 'lock'
  }
}

export const getAuthenticationTranslationKey = (authenticationMethod: AuthenticationMethod) =>
  authenticationMethod.replace('.', '_')
